import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { OrganizationReach } from '../model/organization/organization-reach.model';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ReachService {
  private httpClient = inject(HttpClient);

  public getReachList(): Observable<OrganizationReach[]> {
    return this.httpClient.get<any[]>(
      `${environment.apiUrl}/api/scopes`,
    ).pipe(
      map((responseList: any[]): OrganizationReach[] => (responseList ?? []).map(
        (response: any): OrganizationReach => OrganizationReach.createFromApi(response),
      )),
    );
  }
}
